// The reader's moves in the ending that lost a winning position, and whether
// they stood winning there at all: the library's "Lost a won ending" filter.
// Only the reader's own moves, and only in games the reader went on to lose:
// a win thrown away and then won back, or drawn, is not a lost won ending.
import { type FactExtractor, type ScannedGame } from '../extractor.ts';
import { type EndingBlunder, type GameFacts } from '@chess/api-model';

export const endingBlunders: FactExtractor = {
  id: 'ending-blunders',
  extract(game: ScannedGame, facts: GameFacts): void {
    const { fromPly, toPly } = game.range('ending');
    const found: EndingBlunder[] = [];
    let winning = false;
    for (let ply = fromPly + 1; ply <= toPly; ply++) {
      if (!game.isReaders(ply)) continue;
      const before = game.pawnsAt(ply - 1);
      if (before !== undefined && before >= game.rules.winningPawns) winning = true;
      const move = game.moves[ply - 1];
      if (facts.outcome !== 'loss') continue;
      if (!move || !game.judge.kind(ply, move, game.reader) || !game.threw(ply)) continue;
      found.push({ ply, san: move.san, before: before!, after: game.pawnsAt(ply)! });
    }
    facts.endingBlunders = found;
    facts.winningEnding = winning;
  },
};
